import type { DashboardSummeryBaseInfo, PermanentPostReportViewModel } from "@payping/api";
import { GetWithdraws } from "@payping/redux/actions";
import { dateFormats, jalaliNow, toUtc, utcNow } from "@payping/utils/dateUtils";

type localeType = "en" | "fa";
type PickerRangesLocale = localeType;
const getLocaleNowMethod = (locale: PickerRangesLocale): "jalaliNow" | "utcNow" =>
  locale === "fa" ? "jalaliNow" : "utcNow";
const locale = "fa";
const nowMethod = getLocaleNowMethod(locale);

export interface ListParams {
  pageNumber?: number;
  pageSize?: number;
}
export enum SelectedDates {
  weekly = 1,
  monthly = 2,
  yearly = 3,
}

export type SummationFilters = DashboardSummeryBaseInfo & {
  currentFromDate?: string;
  currentToDate?: string;
  previousFromDate?: string;
  previousToDate?: string;
  selectedDateType?: SelectedDates;
};

export type SummationNumberFilters = Pick<SummationFilters, "terminalId" | "selectedDateType">;
export type SummationStringFilters = Pick<
  SummationFilters,
  "clientId" | "currentFromDate" | "currentToDate" | "previousFromDate" | "previousToDate"
>;
export type WithdrawsFilters = GetWithdraws & ListParams;
export type WithdrawsNumberFilters = Pick<WithdrawsFilters, "pageSize" | "pageNumber">;
export type WithdrawsStringFilters = Pick<WithdrawsFilters, "clientId" | "fromDate" | "toDate" | "searchText">;
export type ItemSaleFilters = PermanentPostReportViewModel & ListParams;

const dateUtils = { jalaliNow, utcNow };

// used for summation filter & ItemSale filter
const localeToDate = dateUtils[nowMethod]({
  manipulate: [{ args: ["day"], method: "endOf" }],
  toFormat: dateFormats.standard.utcDateTime,
}).string;
const utcToDate = toUtc({ date: localeToDate }).string;

// used for summation filter & ItemSale filter
const localeFromDate = dateUtils[nowMethod]({
  manipulate: [
    { args: [30, "days"], method: "subtract" },
    { args: ["day"], method: "startOf" },
  ],
  toFormat: dateFormats.standard.utcDateTime,
}).string;
const utcFromDate = toUtc({ date: localeFromDate }).string;

export const initialSummationFilters: SummationFilters = {
  clientId: undefined,
  fromDate: utcFromDate,
  terminalId: undefined,
  toDate: utcToDate,
};

export const initialWithdrawsFilters: WithdrawsFilters = {
  clientId: "",
  fromDate: undefined,
  toDate: undefined,
};

export const initialItemSaleFilters: ItemSaleFilters = {
  customerCodes: [],
  endDate: utcToDate,
  productCodes: [],
  startDate: utcFromDate,
};
